module.exports = __webpack_public_path__ + "static/media/graduation-cap.be0de273.svg";